import { Snackbar } from 'components/Snackbar';
import { useLoader } from 'hooks/utilHooks';
import {
  createContext,
  ReactNode,
  useCallback,
  useEffect,
  useState,
} from 'react';
import { ReportService } from 'services';
import { IReport } from 'types/Report';

import { AlertColor } from '@mui/material';

export interface IReportContext {
  getReport: Function;
  getReportCb: Function;
  report: IReport[];
  loadingList: boolean;
}

interface ISnackbar {
  message: string | null;
  variant?: AlertColor | undefined;
}

export const ReportContext = createContext<IReportContext>(
  {} as IReportContext
);

type Props = {
  children: ReactNode;
};

export const ReportProvider = ({ children }: Props) => {
  const [report, setReport] = useState<IReport[]>([]);

  const [snackbar, setSnackbar] = useState<ISnackbar>({
    message: '',
    variant: 'info',
  });

  const loadingList = useLoader(true);

  const getReport = useCallback(async () => {
    try {
      const report = await ReportService.getReport();
      return report;
    } catch (error) {
      setSnackbar({
        message: 'Não foi possível listar o relatório',
        variant: 'error',
      });
      return [];
    }
  }, []);

  const getReportCb = useCallback(
    async (force = false) => {
      if (force === true) {
        const report = await getReport();
        setReport(report);
      }
    },
    [setReport, getReport]
  );

  useEffect(() => {
    getReport().then((report) => {
      loadingList.hideLoader();
      setReport(report);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setReport, getReport]);

  useEffect(() => {
    getReportCb();
  }, [getReportCb]);

  return (
    <ReportContext.Provider
      value={{
        getReport,
        getReportCb,
        report,
        loadingList: loadingList.loading,
      }}
    >
      {children}

      <Snackbar
        text={snackbar.message}
        snackbarOpen={Boolean(snackbar.message)}
        setSnackbarOpen={() => {
          setSnackbar({
            message: '',
          });
        }}
        severityType={snackbar.variant}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      />
    </ReportContext.Provider>
  );
};
